export default __webpack_public_path__ + "locales/lv/DeleteProfileEverDialog.json?hash=850d2be3099937800e5a49e68c58e52c";